import deepMerge from 'deepmerge'

// We need a way to detect our environment so we have a fallback in case it gets not defined
const environment = /^((www|dsl|mobile)\.)?1und1\.de$/.test(location.host)
  ? 'live'
  : /^pre(-(www|dsl|mobile))?\.1und1\.de$/.test(location.host) || /^.*\.prod\..*\.server\.lan$/.test(location.host)
  ? 'prelive'
  : 'qa'

// We merge our defaults with the current window.reactContext
window.reactContext = deepMerge(
  {
    environment,
    baseApiUrl:
      (window.__oneandoneAccess && window.__oneandoneAccess.baseApiUrl) ||
      {
        live: 'https://api.1und1.de',
        prelive: 'https://pre-api.1und1.de',
        qa: location.origin.replace(/(https?:\/\/)?(proxy\.)?((www|dsl|mobile)\.)?(.*)/, '$1$2api.$5')
      }[environment],
    colors: {},
    shop: {
      current: 'mobile-nk',
      products: {
        articles: [],
        bundles: []
      }
    },
    psId: window.__oneandoneAccess?.PROFI_SELLER_ID
  },
  window.reactContext || {}
)

/**
 * We use getters so the values can be changed while runtime for better testing
 */
export default new (class ConfigService {
  constructor() {
    this.configs = {
      api: {
        get base() {
          return window.reactContext.baseApiUrl
        },
        get cart() {
          return window.reactContext.cartApiUrl || this.base + '/wws/api'
        },
        get contact() {
          return window.reactContext.contactApiUrl || this.base + '/contact'
        },
        get kwk() {
          return window.reactContext.kwkApiUrl || this.base + '/kwk'
        }
      },
      get colors() {
        return window.reactContext.colors
      },
      get environment() {
        return window.reactContext.environment
      },
      shop: {
        get current() {
          return window.reactContext.shop.current || 'default'
        },
        get products() {
          return window.reactContext.shop.products
        }
      },
      get psId() {
        return window.reactContext.psId
      },
      contact: {
        categories: ['consult', 'tariffs', 'kwk', 'ads', 'tu', 'bill', 'dsa'],
        products: [
          'adsl',
          'smallscreen',
          'bigscreen',
          'fibre',
          'mail',
          'hosting',
          'server',
          'email',
          'domain',
          'marketing',
          'shops'
        ],
        topics: ['line', 'phone', 'providerchange', 'router', 'contract', 'technical', 'services', 'other']
      },
      kwk: {
        products: ['dsl', 'allnetflat', 'unlimited', 'dataflat', 'glasfaser', 'all'],
        subjects: ['tip_for_you', 'interesting_for_you', 'my_tip'],
        titles: ['ms', 'mr', 'none']
      }
    }
  }

  get(key) {
    return key.split('.').reduce((p, c) => p && p[c], this.configs)
  }

  set(key, value) {
    key.split('.').reduce((o, p, i) => (o[p] = key.split('.').length === ++i ? value : o[p] || {}), this.configs)
  }
})()
